<mat-dialog-content class="modal-header"><h2 mat-dialog-title>REGISTRAR EQUIPO</h2></mat-dialog-content>

<form #modelForm="ngForm" (ngSubmit)="onSubmit(modelForm)" appIdentityRevealed>

<mat-dialog-content class="modal-body">

  <div class="content">
    <div class="form-horizontal">
        <div class="form-group">
          <label class="col-md-2 control-label">Equipo (*):</label>
            <div class="col-md-4">
              <mat-form-field appearance="outline" hideRequiredMarker>
                <mat-label>Equipo</mat-label>
                <input matInput type="text" placeholder="equipo" [(ngModel)]="data.equipo.equipo" [disabled]="!data.enableEdit" maxlength="40"
                name="equipo"
                required
                >
              </mat-form-field>
            </div>  

            <label class="col-md-2 control-label">Marca (*):</label>
            <div class="col-md-4">
              <mat-form-field appearance="outline" hideRequiredMarker>
                <mat-label>Marca</mat-label>
                <input matInput type="text" placeholder="marca" [(ngModel)]="data.equipo.marca" [disabled]="!data.enableEdit" maxlength="40"
                name="marca"
                required
                >
              </mat-form-field>                
            </div>
            
        </div>   
        <div class="form-group">
          <label class="col-md-2 control-label">Modelo (*):</label>
            <div class="col-md-4">
              <mat-form-field appearance="outline" hideRequiredMarker>
                <mat-label>Modelo</mat-label>
                <input matInput type="text" placeholder="modelo" [(ngModel)]="data.equipo.modelo" [disabled]="!data.enableEdit" maxlength="40"
                name="modelo" required
                >
              </mat-form-field>
            </div>  

          <label class="col-md-2 control-label">Serie:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Serie</mat-label>
              <input matInput type="text" placeholder="serie" [(ngModel)]="data.equipo.serie" [disabled]="!data.enableEdit" maxlength="40"
                name="serie"
              >
            </mat-form-field>            
          </div>  
        </div>

    </div>  
  </div>  
  <div class="content">
    <div class="block">
      <!-- <div class="block-header">
        <h3 class="block-title">Documentación Requerida</h3>
      </div> -->
      <mat-tab-group>
        <mat-tab label="Documentación Requerida">
        <div class="table-responsive">
          <table mat-table [dataSource]="data.equipo.documentos" class="table table-striped table-vcenter">
            <ng-container matColumnDef="nombre">
              <th mat-header-cell *matHeaderCellDef>Nombre</th>
              <td mat-cell *matCellDef="let element">{{ element.documento }}</td>
            </ng-container>
    
            <ng-container matColumnDef="idRequisito">
              <th mat-header-cell *matHeaderCellDef>Requisito</th>
              <td mat-cell *matCellDef="let element">{{ element.requisito }}</td>
            </ng-container>

            <ng-container matColumnDef="fechaVencimiento">
              <th mat-header-cell *matHeaderCellDef>Fecha de vencimiento</th>
              <td mat-cell *matCellDef="let element; let i = index">
                <ng-container *ngIf="element.idEstado == 1">
                  {{ element.fechaVencimiento | date:'dd/MM/yyyy' }}
                </ng-container>

                <ng-container *ngIf="element.idEstado !== 1">
                
                  <mat-form-field appearance="outline" *ngIf="element.controlarFechas">
                    <input
                      matInput
                      [matDatepicker]="pckrFechaVencimiento"
                      [(ngModel)]="element.fechaVencimiento"
                      [disabled]="element.idEstado == 1"
                      [name]="'fechaVencimiento_'+ i"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="pckrFechaVencimiento"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #pckrFechaVencimiento></mat-datepicker>    
                  </mat-form-field>

                </ng-container>
              </td>
            </ng-container>
            
            <ng-container matColumnDef="idDocumento">
              <th mat-header-cell *matHeaderCellDef>Doc.</th>
              <td mat-cell *matCellDef="let element">
                <!-- <a>VER</a> -->
                <a (click)="downloadDocumentFromService(element)">{{element.nombreArchivo}}</a>
              </td>
            </ng-container>

            <ng-container matColumnDef="estado">
              <th mat-header-cell *matHeaderCellDef>Estado</th>
              <td mat-cell *matCellDef="let element">
                <!-- <a>VER</a> -->
                {{element.estado}}
              </td>
            </ng-container>

            <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let element"> 
                <app-adjuntar-documento 
                  *ngIf="element.idEstado == 0 || element.idEstado == 2"
                  [codigoSolicitud]="data.equipo.codigoSolicitud" 
                  [filename]="element.nombre" 
                  [idSolicitud]="data.equipo.idSolicitud" 
                  [model]="element" 
                  [tipoSeccion]="tipoSeccion" 
                  (onUploadFinished)="addItem($event)"
                  (onRemoveDocument)="removeItem($event)"
                  ></app-adjuntar-documento>                
              </td>
            </ng-container>
            
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
        </mat-tab>
        <mat-tab label="Historial Comentarios">
          <app-log-table [listaLogModel]="logs"></app-log-table>
        </mat-tab>
      </mat-tab-group>
        <!-- <div class="block-content">
      </div> -->
    </div>
  </div>
  
  <div class="content">
    <div class="form-horizontal">
      <div class="form-group">
        <label class="col-md-2 control-label">Comentarios:</label>
        <div class="col-md-9">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Comentarios</mat-label>
            <textarea
              matInput
              placeholder="Comentarios"
              rows="5"
              name="comentarios"
              [(ngModel)]="data.equipo.comentarios" [maxlength]="2000"
            ></textarea>
            <!-- 
              [disabled]="modelEquipo.idEstado === 2" -->
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-actions">
  <button type="submit" class="btn btn-naranja" [disabled]="modelForm.invalid" mat-button ><mat-icon>save</mat-icon> Guardar</button>
  <!-- cdkFocusInitial -->
  <button type="button" class="btn btn-naranja2" (click)="onNoClick()" mat-button ><mat-icon>exit_to_app</mat-icon> Cancelar</button>
</mat-dialog-actions>

</form>
<!-- <pre>{{data | json}}</pre> -->